import React from 'react'

import { CustomerSupportImage } from '@/legacy-src/components/CustomerSupportImage'
import { type PageBlockType } from '@/legacy-src/components/pageBlocks/types'
import { ButtonLink } from '@/legacy-src/components/ui/button'
import Container from '@/legacy-src/rebrand/Container'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import Icon from '../../icons/Icon'
import SupportChatOpenButton from '../../support/SupportChatOpenButton'
import { ContentHeader } from '../components/ContentHeader'
import PageBlock from '../components/PageBlock'

// name is optional in the type because we are using this block standalone as well
const CustomerSupportBlock: React.FC<{ name?: string; data?: PageBlockType; isBusinessPage?: boolean }> = ({
  name,
  isBusinessPage,
  data,
}) => {
  const { t } = getTranslate()

  return (
    <PageBlock name={name} color="sand" size="sm" isBusinessPage={isBusinessPage} common={data?.common}>
      <Container className="block tablet:flex tablet:items-center tablet:justify-between">
        <div className="py-4">
          <ContentHeader
            headlineText={t('components.pageBlocks.customerSupport.title')}
            text={t('components.pageBlocks.customerSupport.note')}
            badge={{
              text: t('components.pageBlocks.customerSupport.tag'),
              className: data?.common?.backgroundColor === 'pink' ? 'text-pink-500' : '',
            }}
            align="left"
          />
          <div className="laptop:flex">
            <SupportChatOpenButton variant="yellow" size="medium" className="my-2 mr-3 w-full tablet:w-auto">
              <Icon icon="talk" size="sm" className="mr-2" />
              {t('components.pageBlocks.customerSupport.chat')}
              <Icon icon="up" color="primary" className="ml-5 rotate-45" />
            </SupportChatOpenButton>
            <ButtonLink
              href={`mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}`}
              variant="yellow"
              size="medium"
              className="my-2 w-full tablet:w-auto"
            >
              <Icon icon="email" size="sm" className="mr-2" />
              {t('components.pageBlocks.customerSupport.email')}
              <Icon icon="up" color="primary" className="ml-5 rotate-45" />
            </ButtonLink>
          </div>
        </div>
        <div className="relative w-full tablet:max-w-max">
          <img src={'/images/svg/styleElements/hy.svg'} className="h-[320px] w-[320px] tablet:mr-10" alt="Hedepy" />
          <div className="absolute bottom-16 left-12 text-left">
            <div className="-mb-4 ml-16">
              <h4 className="m-0 rounded-xl bg-white p-3 text-xl">
                {t('components.pageBlocks.customerSupport.textBubble')}
              </h4>
              <img
                src="/images/svg/styleElements/bubble-tip-white.svg"
                alt="tip"
                className="z-20 -mt-3 h-5 text-left"
              />
            </div>
            <CustomerSupportImage size="big" />
          </div>
        </div>
      </Container>
    </PageBlock>
  )
}

export default CustomerSupportBlock
